var map = {
	"./about/welcome.png": 2606,
	"./bg/14.png": 9427,
	"./bg/home/10.png": 4967,
	"./bg/home/15.png": 3985,
	"./bg/home/7.png": 4196,
	"./bg/home/8.png": 6464,
	"./bg/home/9.png": 4729,
	"./proj/Ellipse 9.png": 7951,
	"./proj/Ellipse 9old.png": 1368,
	"./proj/Movie_List.png": 5852,
	"./proj/Self-Portrait.png": 2114,
	"./proj/Shopping-List.png": 2029,
	"./proj/contactform.png": 9813,
	"./proj/dcd1.png": 9373,
	"./proj/dcd2.png": 5586,
	"./proj/dcdweb.jpg": 4682,
	"./proj/dcdweb.png": 6240,
	"./proj/ecommerce.png": 2879,
	"./proj/elenafacts.png": 2668,
	"./proj/hackernews.png": 7227,
	"./proj/healthymeals.png": 5329,
	"./proj/homerental.png": 1772,
	"./proj/iroirowebstudio.png": 5621,
	"./proj/iws1.png": 9111,
	"./proj/iws2.png": 1596,
	"./proj/mdiazweb.png": 3550,
	"./proj/mySite.png": 537,
	"./proj/pfe.png": 4896,
	"./proj/restaurant.png": 2808,
	"./proj/rnm.png": 7176,
	"./proj/rogonzalez.png": 8546,
	"./proj/ronQuote.png": 5535,
	"./proj/slider.png": 8141,
	"./proj/squareapi.png": 2487,
	"./proj/tdbcard.png": 4924,
	"./proj/tdbranddesign.png": 3203,
	"./proj/twh.png": 4583,
	"./proj/twh_design.png": 6185,
	"./shared/3.svg": 3538,
	"./shared/design/error_light.svg": 8982,
	"./shared/design/experience.svg": 7270,
	"./shared/design/fixbutterfly_light.svg": 6665,
	"./shared/design/hellobutterfly.svg": 4660,
	"./shared/design/likes.svg": 8787,
	"./shared/design/mail_dark.svg": 3237,
	"./shared/design/mail_light.svg": 5526,
	"./shared/design/mailsent_light.svg": 703,
	"./shared/design/skills.svg": 4459,
	"./shared/design/write_light.svg": 9719,
	"./shared/desktop_dark.svg": 926,
	"./shared/desktop_light.svg": 3090,
	"./shared/email.svg": 6048,
	"./shared/icon-close.svg": 2744,
	"./shared/icon-hamburger.svg": 9621,
	"./shared/instagram.svg": 332,
	"./shared/logo-dark.png": 8917,
	"./shared/logo-light.png": 7027,
	"./shared/mobile_dark.svg": 8944,
	"./shared/mobile_light.svg": 6198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;